import { PRODUCTS } from '../data/products';
import WaitlistCta from './WaitlistCta';
import styles from './InfoPanel.module.css';

export default function InfoPanel({ onOpenWaitlist }) {
  return (
    <div className={styles.panel}>
      <div className={styles.body}>
        <h1 className={styles.title}>CMPND.DEV</h1>

        <p className={styles.description}>
          The software engineering stack, rebuilt for AI velocity
        </p>

        <ul className={styles.capabilities}>
          {PRODUCTS.map((p) => (
            <li key={p.id}>
              {p.name} - {p.tagline}
            </li>
          ))}
        </ul>

        <WaitlistCta onOpen={onOpenWaitlist} />
      </div>
    </div>
  );
}
